
function getIconOpacity(d, i, connectionChains, clickSelection, hoverSelection,
  chainSelection){

  let dimmedOpacity = 0;
  let iconOpacity = 1;

  const currentIcon = +d.ID;

  let clickChain = [];
  let chainChain = [];
  let hoverChain = [];
  if(hoverSelection >= 0){
    hoverChain = connectionChains[hoverSelection]['chainIcons'];
    iconOpacity = (connectionChains[hoverSelection]['depthOfIcons'][currentIcon] < 3)
      ? 1
      : 0.6
  }

  if(clickSelection >= 0){
    clickChain = connectionChains[clickSelection]['chainIcons'];
    chainChain = connectionChains[chainSelection]['chainIcons'];
    // const opacityFactor = connectionChains[clickSelection]['depthOfIcons'][currentIcon];
    // iconOpacity = d3.max([1 - opacityFactor**4 / (25), 0.6]);
    iconOpacity = (connectionChains[clickSelection]['depthOfIcons'][currentIcon] < 3)
      ? 1
      : 0.6
  }


  if(
    // unless other hovered & none clicked & not in hoverchain
    (
      hoverSelection >= 0 &&
      hoverSelection !== currentIcon &&
      clickSelection < 0 &&
      !hoverChain.includes(currentIcon)
    ) ||
    // unless none hovered & and other clicked & not in clickchain
    (
      hoverSelection < 0 &&
      clickSelection >= 0 &&
      clickSelection !== currentIcon &&
      !clickChain.includes(currentIcon)
    ) ||
    // unless hovered & other clicked & not in clickchain
    (
      hoverSelection === currentIcon &&
      clickSelection >= 0 &&
      clickSelection !== currentIcon &&
      !clickChain.includes(currentIcon)
    ) ||
    // other clicked & other hovered & not in clickchain
    (
      clickSelection >= 0 &&
      clickSelection !== currentIcon &&
      hoverSelection >= 0 &&
      hoverSelection !== currentIcon &&
      !clickChain.includes(currentIcon)
    ) ||
    (
      clickSelection >= 0 &&
      !chainChain.includes(currentIcon)
    )
  ){
    iconOpacity = dimmedOpacity;
  }

  if(chainChain.includes(+d.ID) && iconOpacity === 0){
    iconOpacity = 0.6;
  }

  return iconOpacity;

}



function getTextOpacity(d, connectionChains, clickSelection, hoverSelection,
  chainSelection) {

  if(d.ID === chainSelection){return 1}

  const currentIcon = +d.ID;

  let clickDirect = [];
  let clickChain = [];
  let chainChain = [];
  let hoverDirect = [];
  if(clickSelection >= 0){
    clickDirect = connectionChains[clickSelection]['directIcons'];
    clickChain = connectionChains[clickSelection]['chainIcons'];
    chainChain = connectionChains[chainSelection]['chainIcons'];
}
  if(hoverSelection >= 0){
    hoverDirect = connectionChains[hoverSelection]['directIcons'];
  }

  let textOpacity = 1;
  if(
    // unless none clicked & none hovered
    (
      hoverSelection < 0 &&
      clickSelection < 0
    ) ||
    // unless other hovered & not in direct hover
    (
      hoverSelection >= 0 &&
      hoverSelection !== currentIcon &&
      !hoverDirect.includes(currentIcon)
    ) ||
    // unless other clicked & none hovered & not in click direct
    (
      clickSelection >= 0 &&
      clickSelection !== currentIcon &&
      hoverSelection < 0 &&
      !clickDirect.includes(currentIcon)
    ) ||
    // other clicked & not in clickChain
    (
      clickSelection >= 0 &&
      clickSelection !== currentIcon &&
      !clickChain.includes(currentIcon)
    ) ||
  (
    clickSelection >= 0 &&
    !chainChain.includes(currentIcon)
  )
  ){
    textOpacity = 0;
  }


  return textOpacity;


}

export {
  getIconOpacity,
  getTextOpacity
}
